import { Person2Outlined } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IRideDto } from "@ryde/shared";

import { AccessControl } from "../../../access-control";
import { RideStationBulkActionsMenu } from "./ride-station-bulk-actions-menu";
import { RideStationBulkActionsForm } from "./ride-station-bulk-actions.form";
import { RideBulkActionModeEnum } from "./ride-station-bulk-actions.models";
import { RideStationBulkMoveForm } from "./ride-station-bulk-move.form";
import { RideStationsBulkActionsWrapperStyled } from "./ride-stations.styled";
import { useRideStationBulkActionsMode } from "./use-ride-station-bulk-actions-mode";

interface IRydeStationBulkActions {
  rideDto: Partial<IRideDto>;
}

export const RydeStationBulkActions: FC<IRydeStationBulkActions> = ({
  rideDto,
}) => {
  const { t } = useTranslation();
  const {
    selectedPassengersIds,
    activeMode,
    isMovePassengersAllowed,
    updateStationsButtonRef,
    movePassengersButtonRef,
    panelBackButtonRef,
    showMenu,
    showUpdateStations,
    showMovePassengers,
  } = useRideStationBulkActionsMode(rideDto);

  if (!selectedPassengersIds?.length) {
    return null;
  }

  return (
    <AccessControl entity="ride" action="update">
      <RideStationsBulkActionsWrapperStyled>
        {activeMode === RideBulkActionModeEnum.Menu && (
          <div className="bulk_actions">
            <div className="row_top_info_bulk">
              <label>{t("ride.BULK_ACTION_TITLE_LABEL")}:</label>
              <Person2Outlined className="person_icon" />
              <span>
                <strong>{selectedPassengersIds.length}</strong>
                {t("ride.BULK_ACTION_SELECTED_PASSENGER_COUNT_LABEL", {
                  count: selectedPassengersIds.length,
                })}
              </span>
            </div>

            <RideStationBulkActionsMenu
              isMovePassengersAllowed={isMovePassengersAllowed}
              updateStationsButtonRef={updateStationsButtonRef}
              movePassengersButtonRef={movePassengersButtonRef}
              onUpdateStationsClick={showUpdateStations}
              onMovePassengersClick={showMovePassengers}
            />
          </div>
        )}

        {activeMode === RideBulkActionModeEnum.UpdateStations && (
          <RideStationBulkActionsForm
            rideDto={rideDto}
            backButtonRef={panelBackButtonRef}
            onBack={showMenu}
          />
        )}

        {activeMode === RideBulkActionModeEnum.MovePassengers && (
          <RideStationBulkMoveForm
            rideDto={rideDto}
            backButtonRef={panelBackButtonRef}
            onBack={showMenu}
          />
        )}
      </RideStationsBulkActionsWrapperStyled>
    </AccessControl>
  );
};
